module.exports = __webpack_public_path__ + "img/right-icon.d5f5ebda.png";